import React from 'react';
import { generateWhatsAppLink } from '../../mock';

const WhatsAppFloat = () => (
  <a
    href={generateWhatsAppLink()}
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-float"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-float-btn"
  >
    <svg viewBox="0 0 32 32" width="32" height="32" aria-hidden="true">
      <path
        fill="currentColor"
        d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.973 0-7.51 6.11-13.618 13.618-13.618 7.51 0 13.618 6.11 13.618 13.618s-6.108 13.618-13.618 13.618zM21.99 19.058c-0.196-0.098-1.163-0.572-1.342-0.637-0.182-0.065-0.313-0.098-0.445 0.098s-0.508 0.638-0.622 0.77c-0.114 0.13-0.229 0.147-0.425 0.049-0.196-0.099-0.826-0.304-1.573-0.969-0.581-0.518-0.974-1.157-1.088-1.353s-0.012-0.302 0.086-0.4c0.088-0.088 0.196-0.229 0.294-0.344s0.131-0.196 0.196-0.327c0.065-0.131 0.033-0.245-0.016-0.344s-0.445-1.070-0.608-1.465c-0.159-0.385-0.32-0.333-0.445-0.339-0.114-0.005-0.245-0.007-0.376-0.007s-0.343 0.049-0.523 0.245c-0.18 0.196-0.688 0.672-0.688 1.64s0.705 1.902 0.803 2.033c0.098 0.131 1.394 2.128 3.375 2.984 0.471 0.203 0.838 0.325 1.125 0.416 0.474 0.151 0.905 0.13 1.246 0.079 0.38-0.057 1.163-0.476 1.328-0.935 0.164-0.46 0.164-0.854 0.114-0.935-0.048-0.080-0.18-0.13-0.376-0.229z"
      />
    </svg>
  </a>
);

export default WhatsAppFloat;
